export default "__VITE_ASSET__UIFIjP0e__"